module.exports = __webpack_public_path__ + "static/html-4c0f6786c2e2eb87a20fe64d30936f68.png";